// Default CMS content — mirrors backend DEFAULT_CONTENT so the storefront
// renders instantly before /api/settings resolves.
export const DEFAULT_CONTENT = {
  announcement: { enabled: true, text: "Free delivery on orders above ₹999 • 100% Certified Organic" },
  header: {
    brand_name: "LIVENEAT",
    brand_tagline: "Organic",
    show_whatsapp_cta: true,
    nav: [
      { label: "Home", to: "/" },
      { label: "Shop", to: "/shop" },
      { label: "Categories", to: "/categories" },
      { label: "Wellness Consultants", to: "/consultants" },
      { label: "Wellness Blog", to: "/blog" },
      { label: "About Us", to: "/about" },
      { label: "Contact", to: "/contact" },
    ],
  },
  hero: {
    badge: "Premium Organic Wellness Marketplace",
    line1: "LIVE BETTER.",
    line2: "EAT BETTER.",
    line3: "CHOOSE ORGANIC.",
    subtext: "Discover carefully selected organic, natural and wellness products for a healthier everyday lifestyle.",
    image: "https://images.unsplash.com/photo-1512621776951-a57141f2eefd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400",
    primary_cta: { label: "Shop Now", to: "/shop" },
    secondary_cta: { label: "Talk to a Wellness Consultant", to: "/consultants" },
    card_title: "5000+ Products",
    card_subtitle: "Curated for wellness",
    features: [
      { icon: "leaf", label: "100% Natural" },
      { icon: "shield-check", label: "Certified Organic" },
      { icon: "truck", label: "Fast Delivery" },
    ],
  },
  sections: [
    { id: "categories", type: "categories", enabled: true, title: "Shop by Category", subtitle: "Explore" },
    { id: "wellness", type: "wellness_goals", enabled: true, title: "Shop by Wellness Goal", subtitle: "What are you looking for?" },
    { id: "trending", type: "products", enabled: true, title: "Trending Now", subtitle: "Hot picks", source: "trending" },
    { id: "promo", type: "promo", enabled: true, title: "Fresh Deals, Every Day", subtitle: "Up to 40% off on superfoods, dry fruits and wellness essentials. Limited time only.", cta: { label: "Grab Deals", to: "/shop?sort=discount" } },
    { id: "best", type: "products", enabled: true, title: "Best Sellers", subtitle: "Customer favourites", source: "best_sellers" },
    { id: "arrivals", type: "products", enabled: true, title: "New Arrivals & Deals", subtitle: "Just in", source: "arrivals" },
    { id: "consultant_cta", type: "consultant_cta", enabled: true, title: "Need personalised wellness advice?", subtitle: "Connect with our certified wellness consultants over WhatsApp, video or a callback." },
  ],
  footer: {
    about: "A curated online marketplace for organic, natural, healthy and wellness-focused products. Live better, eat better, choose organic.",
    tagline: "LIVE BETTER. EAT BETTER. CHOOSE ORGANIC.",
    columns: [
      { title: "Shop", links: [["All Products", "/shop"], ["Categories", "/categories"], ["Best Sellers", "/shop?section=best_sellers"], ["New Arrivals", "/shop?section=new_arrivals"]] },
      { title: "Wellness", links: [["Wellness Consultants", "/consultants"], ["Wellness Blog", "/blog"], ["Shop by Goal", "/#wellness-goals"], ["Immunity & Wellness", "/shop"]] },
      { title: "Customer", links: [["My Account", "/account"], ["Orders", "/account"], ["Wishlist", "/wishlist"], ["Contact Us", "/contact"]] },
      { title: "Support", links: [["FAQs", "/contact"], ["Shipping Policy", "/contact"], ["Return Policy", "/contact"], ["Privacy Policy", "/contact"]] },
    ],
  },
};

export const getContent = (settings) => (settings && settings.content) || DEFAULT_CONTENT;

export const toPascal = (s) =>
  (s || "leaf").split("-").map((w) => w.charAt(0).toUpperCase() + w.slice(1)).join("");
